/* Routes login */
export const login = 'login'
export const urlGlobal = "https://api.agendaenlinea.cl/api";

/* Routes Patient */
export const patient = {
  api: {
    resource: '/patient',
    relationship: '/patient/relationship',
    register: '/patient/register2',
    update_massive: '/patient/update_massive',
    exists: '/patient/exists',
    offices: '/patient/offices',
    reserves: '/patient/reserves',
    appointments: '/patient/appointments',
    info: '/patient/appointments/info',
    comunities: '/doctor/comunities',
    regions: '/doctor/regions',
    lang: {
      enabled: '/language',
      set: '/language/set',
      trans: '/language/translate'
    },
    exists: '/patient/exists',
    filter: '/patient/filter',
    relationship: '/patient/relationship',
    vinculated: '/patient/vinculated',
    underlyings: '/patient/underlyings',
    search: '/patient/search',
    upload: {
      underlying: '/patient/upload',
      avatar: '/patient/upload'
    },
    bonus_tasks: '/patient/bonus_tasks',
    bonuses: '/patient/bonuses',
  }
}

/* Routes Doctor */
export const doctor = {
  register: 'register',
  speciality: {
    list: '/specialities',
    listDoctor: '/doctor/specialities'
  },
  api: {
    facebook: '/doctor/facebook',
    lang: {
      enabled: '/language',
      set: '/language/set',
      trans: '/language/translate'
    },
    register: '/doctor/register',
    exists: '/doctor/exists',
    upload: {
      avatar: '/doctor/avatar',
      office: '/doctor/upload/office',
      subordinate: '/doctor/upload/subordinate'
    },
    list: {
      doctor: '/doctor/doctor',
      office: '/doctor/offices'
    },
    patient: {
      exists: '/patient/exists'
    },
    diary: {
      store: '/diary',
      update: '/diary/'
    },
    comunities: '/doctor/comunities',
    regions: '/doctor/regions',
    offices: '/doctor/offices',
    schedules: '/doctor/schedules',
    turns: '/doctor/schedules/turn',
    extraHours: '/doctor/extra-hours',
    absences: '/doctor/absences',
    search: '/doctor/search',
    tracking: '/doctor/tracking',
    subordinates: '/doctor/subordinates',
    roles: '/doctor/roles',
    bids: '/doctor/bids'
  }
}

/* Routes Public */
export const public_api = {
  api: {
    regions: '/regions',
    cities: '/cities',
    previsions: '/previsions',
    boxes: '/boxes',
    filter: {
      doctor: '/filter/doctor'
    },
    speciality: {
      list: '/specialities'
    },
    diary: {
      getHours: '/diary/getHoursAvailable'
    },
    patient: {
      store: '/patient/register2'
    },
    type_patients: '/type_patients'
  }
}

/* Prefix of countries enabled */
export const prefix = ['cl', 'pe', 'ar', 'mx', 'co', 'es', 'us', 'bo', 'do', 'cr', 've', 'bo', 'cu']



// WEBPACK FOOTER //
// ./src/config/api.js